<template>
    <kgr-generic-modal
        v-if="showDialog"
        :value="showDialog"
        :headline="headline"
        :width-in-px="500"
        scrollable
        @post-input="closeDialog()"
    >
        <kgr-loading
            v-if="loading"
            inline
        />
        <div v-else-if="clubExamResult">
            <kgr-form-row
                :label="$t('Anmerkung')"
                :error="error"
                field-name="note"
            >
                <textarea
                    v-model.trim="clubExamResult.note"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                ></textarea>
            </kgr-form-row>
            <kgr-form-row
                :label="$t('club.exam.result.status')"
                :error="error"
                field-name="status"
            >
                <kgr-generic-radio
                    v-model="clubExamResult.status"
                    name="status"
                    :options="statusOptions"
                />
            </kgr-form-row>
            <h3
                v-if="clubExamResult.examPartResults.length > 0"
                class="kgr-headline kgr-headline--h2 kgr-headline--text"
            >
                {{ $t('Teilergebnisse') }}
            </h3>
            <kgr-exam-part-result-form
                v-for="part in clubExamResult.examPartResults"
                :key="part.id"
                :exam-part-result="part"
                :error="error"
            />
        </div>
        <template #footer>
            <kgr-button
                :pending="pendingSave"
                @click="save()"
            >
                {{ $t('saveAndClose') }}
            </kgr-button>
            <kgr-button
                type="red"
                @click="deleteResult()"
            >
                {{ $t('Prüfungsergebnis löschen') }}
            </kgr-button>
        </template>
    </kgr-generic-modal>
</template>

<script>
import ClubExamResult from '../../../js/dto/club/ClubExamResult.js';
import ClubExamResultRepository from '../../../js/repository/club/ClubExamResultRepository.js';
import Error from '../../../js/model/Error.js';
import ExamPartResultForm from '../../exams/ExamPartResultForm.vue';
import FormRow from '../../common/form/FormRow.vue';
import GenericModal from '../../common/modal/GenericModal.vue';
import GenericRadio from '../../common/form/radio/GenericRadio.vue';
import KgrButton from '../../common/form/button/KgrButton.vue';
import Loading from '../../common/Loading.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-form-row': FormRow,
        'kgr-exam-part-result-form': ExamPartResultForm,
        'kgr-generic-modal': GenericModal,
        'kgr-generic-radio': GenericRadio,
        'kgr-loading': Loading,
    },
    props: {
        selectedClubExamResult: {
            type: ClubExamResult,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            error: new Error(),
            clubExamResult: null,
            loading: true,
            showDialog: false,
            statusOptions: {
                'club.exam.result.status.success': ClubExamResult.STATUS_SUCCESS,
                'club.exam.result.status.failure': ClubExamResult.STATUS_FAILURE,
            },
            pendingSave: false,
        };
    },
    computed: {
        headline() {
            if (this.clubExamResult) {
                let headline = this.clubExamResult.clubExam.title;
                if (this.clubExamResult.member) {
                    headline += ` - ${this.clubExamResult.member.name}`;
                } else if (this.clubExamResult.dog) {
                    headline += ` - ${this.clubExamResult.dog.name}`;
                }
                return headline;
            }
            return '';
        },
    },
    watch: {
        selectedClubExamResult() {
            if (this.selectedClubExamResult) {
                this.loading = false;
            }
            this.clubExamResult = this.selectedClubExamResult;
        },
    },
    methods: {
        openDialog() {
            this.showDialog = true;
            this.loading = true;
        },
        closeDialog() {
            this.showDialog = false;
            this.$emit('close');
        },
        onKeyUpEnter() {
            this.$emit('enter');
        },
        save() {
            this.pendingSave = true;
            ClubExamResultRepository.update(this.clubExamResult)
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.closeDialog();
                })
                .catch(() => this.$notify.error('Prüfungsergebnis konnte nicht aktualisiert werden'))
                .finally(() => this.pendingSave = false);
        },
        deleteResult() {
            showConfirm(this.$t('confirmInformal'), this.$t('Möchtest du das Prüfungsergebnis wirklich löschen?'), () => {
                ClubExamResultRepository.delete(this.clubExamResult.id)
                    .then(() => {
                        this.$notify.success('Das Prüfungsergebnis wurde gelöscht');
                        this.closeDialog();
                    })
                    .catch(() => this.$notify.error('Das Prüfungsergebnis konnte nicht gelöscht werden'));
            });
        },
    },
};
</script>

<style scoped lang="scss">
</style>
